import type { FC, ComponentType, CSSProperties, ComponentProps } from 'react';

import type { IContainerProps } from './styled';
import {
    CheckboxContainer,
    Container,
    Money,
    Name,
    PlaceCataContainer,
    CardSpinner,
    FooterButton,
    StyledIcon,
} from './styled';

import { Checkbox } from '../Checkbox';
import { Text } from '../Typography/Text';

export { Container as SmallCardContainer } from './styled';

type IFooterButtonProps = ComponentProps<typeof FooterButton> & {
    text: string;
};
interface ICardProps extends IContainerProps {
    onCheckboxChange: (checked: boolean) => void;
    onCardClick: () => void;
    checkboxValue: boolean;
    heading: string;
    worth: string;
    address: string;
    categories: string;
    checkboxTitle?: string | null;
    isLoading?: boolean;
    badge?: ComponentType<{ style: CSSProperties }>;
    footerButtonProps?: IFooterButtonProps;
}

export const Card: FC<ICardProps> = ({
    onCheckboxChange,
    onCardClick,
    checkboxValue,
    heading,
    worth,
    address,
    categories,
    checkboxTitle,
    badge: Badge,
    isLoading,
    footerButtonProps,
}) => {
    return (
        <Container onClick={onCardClick} isLoading={isLoading}>
            {isLoading && <CardSpinner />}
            {Badge && <Badge style={{ gridArea: 'badge' }} />}
            <Name>{heading}</Name>
            <Money>{worth}</Money>
            <PlaceCataContainer>
                <Text>{address}</Text>
                <Text>{categories}</Text>
            </PlaceCataContainer>
            {Boolean(checkboxTitle) && (
                <CheckboxContainer>
                    <Checkbox
                        checked={checkboxValue}
                        handleOnChange={onCheckboxChange}
                        uniqueKey={`Card-${heading}-${worth}`}
                        disabled={isLoading}
                    />
                    {checkboxTitle}
                </CheckboxContainer>
            )}
            {!checkboxTitle && footerButtonProps && (
                <FooterButton {...footerButtonProps}>
                    {footerButtonProps.text}
                    <StyledIcon />
                </FooterButton>
            )}
        </Container>
    );
};

Card.defaultProps = {
    checkboxTitle: undefined,
    badge: undefined,
    isLoading: false,
    footerButtonProps: undefined,
};
